<div class="canvas-container">
    <ng-container *ngIf="isLoading; else content">
        <div class="spinner-overlay">
            <mat-spinner diameter="50"></mat-spinner>
        </div>
    </ng-container>

    <canvas #canvas></canvas>

    <ng-template #content>
        <div class="zoom-buttons">
            <button mat-icon-button class="zoom-btn icon-button-overlay-remove" (click)="zoom(zoomConfig.zoomIn)">+</button>
            <button mat-icon-button class="zoom-btn icon-button-overlay-remove" (click)="zoom(zoomConfig.zoomOut)">-</button>
        </div>
    </ng-template>
</div>
